<div class="attachment-preview" role="dialog" aria-labelledby="attachment-preview-title">
  <div class="attachment-preview__header">
    <h5 id="attachment-preview-title" class="attachment-preview__filename" [title]="attachment?.fileName">
      {{ attachment?.fileName }}
    </h5>
    <div class="attachment-preview__header-actions">
      <button type="button" class="btn-icon-action" (click)="download()"
        [attr.aria-label]="'Download ' + attachment?.fileName">
        <i class="feather icon-download"></i>
      </button>
      <button type="button" class="btn-icon-action" (click)="close()" aria-label="Close preview">
        <i class="feather icon-x"></i>
      </button>
    </div>
  </div>

  <div class="attachment-preview__body">
    <div class="attachment-preview__loading" *ngIf="state === 'loading'">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span>Loading preview…</span>
    </div>

    <div class="attachment-preview__error" *ngIf="state === 'error'">
      <i class="feather" [ngClass]="fileIconClass"></i>
      <p>{{ errorMessage }}</p>
      <button type="button" class="btn btn-primary btn-sm" (click)="download()">
        <i class="feather icon-download"></i> Download
      </button>
    </div>

    <div class="attachment-preview__unsupported" *ngIf="state === 'unsupported'">
      <i class="feather" [ngClass]="fileIconClass"></i>
      <p class="mb-1"><strong>{{ attachment?.fileName }}</strong></p>
      <p class="text-muted mb-2">{{ fileTypeLabel }} — Preview not available for this file type.</p>
      <button type="button" class="btn btn-primary btn-sm" (click)="download()">
        <i class="feather icon-download"></i> Download
      </button>
    </div>

    <div class="attachment-preview__content attachment-preview__content--image" *ngIf="state === 'ready' && previewKind === 'image'">
      <div class="image-zoom-toolbar">
        <button type="button" class="btn btn-light btn-sm" (click)="zoomOut()" aria-label="Zoom out">−</button>
        <button type="button" class="btn btn-light btn-sm" (click)="resetZoom()">{{ (imageZoom * 100) | number:'1.0-0' }}%</button>
        <button type="button" class="btn btn-light btn-sm" (click)="zoomIn()" aria-label="Zoom in">+</button>
      </div>
      <img [src]="safeBlobUrl" [alt]="attachment?.fileName" [style.transform]="'scale(' + imageZoom + ')'" />
    </div>

    <iframe *ngIf="state === 'ready' && previewKind === 'pdf'" class="attachment-preview__iframe"
      [src]="safeBlobUrl" [title]="'Preview of ' + attachment?.fileName"></iframe>

    <div class="attachment-preview__word doc-preview-scroll" *ngIf="state === 'ready' && previewKind === 'word'"
      [innerHTML]="wordHtml"></div>

    <div class="attachment-preview__excel doc-preview-scroll" *ngIf="state === 'ready' && previewKind === 'excel'"
      [innerHTML]="excelHtml"></div>
  </div>
</div>
